module.exports = __webpack_public_path__ + "media/icons/twitter-dc529d4f.svg";